import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Product } from '~shared/models';
import { CarouselButtonApplicationEvent, ProductClickApplicationEvent } from '~shared/modules/application-event/models';
import { PageNameTypes, CarouselActionType } from '~shared/modules/application-event/constants';
import { GaTrackingEventLabel } from '~shared/modules/ga-tracking/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { BlackDealsFeatureFlagService } from '~shared/services/black-deals-feature-flag.service';
import { NavigationHelper } from '~shared/services/navigation-helper.service';

@Component({
  selector: 'app-best-selling-products-list',
  templateUrl: './best-selling-products-list.component.html',
  styleUrls: ['./best-selling-products-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BestSellingProductsListComponent implements OnInit {
  @Input() isMobile: boolean;
  @Input() isDesktop: boolean;
  @Input() products: Product[];

  constructor(
    private applicationEventService: ApplicationEventService,
    private blackDealsFeatureFlagService: BlackDealsFeatureFlagService,
    private navigationHelper: NavigationHelper
  ) {
  }

  ngOnInit(): void {
  }

  onProductClick(product: Product, priceType: PriceTypes, index: number) {
    this.applicationEventService.publish(
      new ProductClickApplicationEvent(
        this.navigationHelper.getCurrentUrl(),
        product,
        priceType,
        PageNameTypes.CustomHubPageMostPopularProducts,
        this.blackDealsFeatureFlagService.isBlackDealsEnabled(),
        index
      )
    );
  }

  onProductCarouselNext(): void {
    this.applicationEventService.publish(
      new CarouselButtonApplicationEvent(
        CarouselActionType.CustomHubPageCarouselButton,
        GaTrackingEventLabel.Right
      )
    );
  }

  onProductCarouselPrev(): void {
    this.applicationEventService.publish(
      new CarouselButtonApplicationEvent(
        CarouselActionType.CustomHubPageCarouselButton,
        GaTrackingEventLabel.Left
      )
    );
  }
}
